import React from 'react';
import DocLink from './DocLink.js';
import MiniTrackComponent from './MiniTrackComponent.js';

export default (props) => {
    return (
        <div className="track-documentation">
          <p>
            The track component also lets you control the volume, muting, soloing, and recording of a track. 
          </p>
          <MiniTrackComponent sequencerEngine={props.sequencerEngine}/>
          <p className="sub-header">
            Volume
          </p>
          <p>
            The blue, horizontal bar, on the left of the track, controls the track's <b>volume</b>. 
          </p>
          <p className="sub-header">
            Muting
          </p>
          <p>
            The green button toggles muting for a track. The number inside the button tells you the track number.
          </p>
          <p className="sub-header">
            Soloing
          </p>
          <p>
            The gray button with an "s", below the mute button, controls "soloing" of the track. When clicked, the button will turn blue and only sounds from that track will be played-- all other sounds will be muted.
          </p>
          <p className="sub-header">
            Record Arm
          </p>
          <p>
            The gray button with a dot, below the solo button, let's you arm a track for recording. When clicked, you'll notice it turns red. The track is armed to record.
          </p>
          <p>
            When armed to record, you can play that track with your computer keyboard or connected MIDI keyboard. 
          </p>
          <p>
            If you then click the red "Record" button at the bottom of the sequencer page (not shown), any notes you play while armed will be recorded into the current pattern.
          </p>
          <p className="sub-header">
            Track Information
          </p>
          <p>
            The track name is shown above the thumbnail and the track's sample tags are shown to the right of it.
          </p>
          <p className="sub-header">
            Effects
          </p>
          <p>
            The <b>black</b> FX button, to the right of the track name, will show the effects for this track. Go to <DocLink name="Effects" goToLink={props.goToLink}/> for more information on effects.
          </p>
        </div>
    );
};
